export const SETTINGS = {
  boxed: true,// boolean
  layout: 'vertical',// horizontal | vertical
  // sidebarBg: '#740000',// string #a3192c
  sidebarBg: '#ffffff',// string #a3192c

  // sidebarColor: '#1F2022',// string
  sidebarColor: '#740000',// string
  sidebarOpened: false,// boolean
  // topbarBg: '#656363',// string
  topbarBg: '#740000',// string
  topbarColor: '#ffffff',// string
  menuItemColor: '#fff',// string
  iconMenuItemColor: '#fff',// string
  loginBtnColor: '#e54021',
  navBarLogo: 'assets/img/logo-creditemoi-contrast.png',
  loginLogo: 'assets/img/logo-creditemoi-no-contrast.png',
  enable_signup: false,
  app_version: 150,
  app_name: 'CMOI',
  pieColor: '#c23531',
  pieShadowColor: 'rgba(0, 0, 0, 0.5)',
  lineTitleColor: 'white',
  lineLegendColor: 'white',
  lineYAxisColor: 'white',
  lineXAxisColor: 'white',
};